import { IsNotEmpty, IsUUID } from 'class-validator';

export class GetHashesHashDto {
  @IsNotEmpty()
  @IsUUID()
  event_id: string;
}
